import React from "react";

const FooterSection = ({ footerText }) => {
  return (
    <footer className="footer-section fw-bold">
      <div className="footer-container">
        <div className="footer-content">
          <span className="footer-text-section">{footerText}</span>
          <div className="footer-circle"></div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;